// Dispatched actions must return an object with `type` attribute
//  or break redux.
//  GTM integration needs a refactor - either pull out of actions,
//  OR revert some changes and pass event to reducer
//  and have reducer call dataLayer.
var gtmPseudoAction = {
  type: 'TAG_MANAGER'
};
export var tagEvent = function tagEvent(tagCategory, tagAction, tagLabel) {
  var _window = window;
  if (_window.dataLayer && _window.dataLayer.push) {
    _window.dataLayer.push({
      event: 'event',
      eventCategory: tagCategory,
      eventAction: tagAction,
      eventLabel: tagLabel
    });
  }
  return gtmPseudoAction;
};
export var tagEngagement = function tagEngagement(tagAction, tagLabel) {
  return tagEvent('paperchecker engagements', tagAction, tagLabel);
};
export var tagFunnel = function tagFunnel(tagAction, tagLabel) {
  return tagEvent('paperchecker funnel', tagAction, tagLabel);
};
export var tagError = function tagError(tagAction, tagLabel) {
  return tagEvent('paperchecker error', tagAction, tagLabel);
};
export var tagAccount = function tagAccount(tagAction, tagLabel) {
  return tagEvent('account', tagAction, tagLabel);
};
export var tagHelp = function tagHelp(tagAction, tagLabel) {
  return tagEvent('help', tagAction, tagLabel);
};
export var tagPageview = function tagPageview(virtualPath) {
  var _window = window;
  if (_window.dataLayer && _window.dataLayer.push) {
    _window.dataLayer.push({
      event: 'virtualPage',
      virtualPagePath: virtualPath
    });
  }
  return gtmPseudoAction;
};